/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["td[_ngcontent-%COMP%]:not(.checkbox-col) {\n  cursor: pointer; }\n\ninput[type=radio][_ngcontent-%COMP%] {\n  height: 1.2rem;\n  width: 1.2rem;\n  vertical-align: middle; }"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/contact/contact.component.scss.shim.ngstyle.js.pre-build-optimizer.js